import { cloneElement } from 'react';
import _ from 'lodash';

export function cloneChildType(children, type, overrideProps) {
    const child = findChildType(children, type);
    return cloneElement(child, overrideProps);
}

function findChildType(children, type) {
    return _.find(children, (child) => child.type === type);
}

export function hasChildType(children, type) {
    return !!findChildType(children, type);
}
